<div
  *ngIf="test"
  (click)="toggleCheckbox()"
  class="order-upsell-product-container"
  [attr.data-qa-id]="test.name + ' Checkbox Card'"
>
  <div class="order-upsell-first-row">
    <div class="order-upsell-checkbox-wrapper">
      <input type="checkbox" [checked]="isSelected" class="order-upsell-checkbox" />
      <label>Add {{ test.name }} - {{ test.price / 100 | currency: 'USD' : 'symbol' : '1.0-2' }}</label>
    </div>
  </div>
  <ng-content></ng-content>
</div>
